import React from 'react';


import { useActions, useAppState } from 'state';
import { OrderFragment } from 'state/gql/_types';

import { extractCurrentItemData } from "utils/forms";
import FormDrawer from 'components/forms/FormDrawer';

import { DrawerActionProps } from 'components/layout/page/PageDrawerAction';

import FormSchema from 'components/tenant/order/schemas/select_vehicle.json';
import Icons from 'components/ui/Icons';
import OrderProcessAction from '../components/OrderProcessAction';
import { OrderActionProps } from './_types';

type FormPayloadType = Pick<OrderFragment,
    | 'vehicle_id'
>

const initialState: FormPayloadType = {
    vehicle_id: ''
};

const SelectVehicleDrawer: React.FC<DrawerActionProps<OrderFragment>> = ({ currentItem, onClose }) => {

    const { updateItem } = useActions().orders;
    const { loading, errors } = useAppState().orders;

    let currentItemId = null;
    let currentItemData = null;
    if (currentItem) {
        currentItemId = currentItem.id;
        currentItemData = extractCurrentItemData<FormPayloadType>(initialState, currentItem);
    }

    return (
        <>
            <FormDrawer<FormPayloadType, OrderFragment, string>
                autoOpen={false}
                formSchema={FormSchema}
                updateAction={updateItem}
                isLoading={loading}
                errors={errors}
                currentItemId={currentItemId}
                initialData={initialState}
                currentItemData={currentItemData}
                onClose={onClose}
            />
        </>
    )
}

export const SelectVehicleAction: React.FC<OrderActionProps> = ({isValid}) => {

    const { currentItem } = useAppState().orders
    if (!currentItem) return null;

    if (!currentItem.vehicle) {
        return (
            <OrderProcessAction<DrawerActionProps<OrderFragment>>
                title='Select Vehicle'
                action={SelectVehicleDrawer}
                icon={Icons.edit}
                props={{currentItem}}
                variant={isValid?"outline":"filled"}
                color={isValid?"gray":"blue"}
            />
        )
    }

    return (
        <OrderProcessAction<DrawerActionProps<OrderFragment>>
            title='Change Vehicle'
            action={SelectVehicleDrawer}
            icon={Icons.edit}
            props={{currentItem}}
            variant={isValid?"outline":"filled"}
            color={isValid?"gray":"blue"}
        />
    )
}